//=require main.js
//=require components/lightslider.min.js
////=require components/light-slider-with-thumbs.js
//=require alertifyjs/build/alertify.js

!function ($, callback) {
    if (typeof $ === 'undefined') {
        $ = require('jquery');
    }

    callback($);

}(window.jQuery, function ($) {
    $(function () {
        $('.sliders-profile-thumb').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.sliders-profile-gallery',
        });

        $('.sliders-profile-gallery').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.sliders-profile-thumb',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            accessibility: true,
            prevArrow: `
                <div class="contractor-showroom-btn prev inverted">
                    <i class="fa fa-angle-left slider-arrow slider-arrow-prev" aria-hidden="true"></i>
                </div>
            `,
            nextArrow: `
                <div class="contractor-showroom-btn next inverted">
                    <i class="fa fa-angle-right slider-arrow slider-arrow-next" aria-hidden="true"></i>
                </div>
            `,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }
            ],
        });

        $('.contractor-portfolio-related-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            // autoplay: true,
            dots: false,
            autoplaySpeed: 3000,
            prevArrow: `
                <div class="contractor-portfolio-related-btn prev inverted">
                    <i class="fa fa-angle-left slider-arrow slider-arrow-prev" aria-hidden="true"></i>
                </div>
            `,
            nextArrow: `
                <div class="contractor-portfolio-related-btn next inverted">
                    <i class="fa fa-angle-right slider-arrow slider-arrow-next" aria-hidden="true"></i>
                </div>
            `,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        // $('.modal-body-share-fb').click(function () {
        //     window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href,
        //         'facebook-share-dialog',
        //         'width=800,height=600'
        //     );
        //     return false;
        // });

        $('.modal-body-share-copy').click(function () {
            let temp = $("<input>");
            $("body").append(temp);
            temp.val(window.location.href).select();
            document.execCommand("copy");
            temp.remove();

            $('#share-portfolio-modal').modal('hide');
            alertify.set('notifier', 'position', 'top-right');
            alertify.success('Sao chép đường dẫn thành công!');
        });

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $(document).delegate('.icon-heart-not-active', 'click', function () {
            let id = $(this).data('id');
            let count_vote = parseInt($(this).data('count'));
            count_vote++
            $(this).replaceWith('<div style="cursor: pointer" class="icon-heart-active d-flex" data-id="' + id + '" data-count="'+ count_vote +'">' +
                '<img src="/images/icons/icon-heart-active.png" class="icon-heart">' +
                '<span class="text-center" style="color: #fff; font-size: 12px; margin-left: 5px">'+ count_vote +'</span>' +
                '</div>')
            $.ajax({
                url: '/vote-portfolio',
                method: "post",
                data: {id: id},
                beforeSend: function () {
                    $('.overlay').fadeIn();
                },
                success: function () {
                    $('.overlay').fadeOut();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log(errorThrown, jqXHR, textStatus)
                }
            })
        })

        $(document).delegate('.icon-heart-active', 'click', function () {
            let id = $(this).data('id');
            let count_vote = parseInt($(this).data('count'));
            count_vote--
            $(this).replaceWith('<div class="icon-heart-not-active d-flex" data-id="' + id + '" data-count="'+ count_vote +'">' +
                '<img src="/images/icons/icon-heart.png" class="icon-heart" style="margin-top: -2px">' +
                '<span class="text-center" style="color: #fff; font-size: 12px; margin-left: 5px">'+ count_vote +'</span>' +
                '</div>')
            $.ajax({
                url: '/remove-vote-portfolio',
                method: "delete",
                data: {id: id},
                dataType: 'json',
                beforeSend: function () {
                    $('.overlay').fadeIn();
                },
                success: function (data) {
                    console.log(data)
                    $('.overlay').fadeOut();
                }
            })
        })

        $(document).delegate('.icon-heart-not-active-detail', 'click', function () {
            let id = $(this).data('id');
            let count_vote = parseInt($(this).data('count'));
            count_vote++
            $(this).replaceWith('<div style="cursor: pointer" class="icon-heart-active-detail" data-id="' + id + '" data-count="'+ count_vote +'">' +
                '<img src="/images/icons/icon-heart-active.png" class="icon-heart">' +
                '<span class="text-center" style="color: #D91636; font-size: 15px; margin-left: 5px">'+ count_vote +'</span>' +
                '</div>')
            $.ajax({
                url: '/vote-portfolio',
                method: "post",
                data: {id: id},
                beforeSend: function () {
                    $('.overlay').fadeIn();
                },
                success: function () {
                    $('.overlay').fadeOut();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log(errorThrown, jqXHR, textStatus)
                }
            })
        })

        $(document).delegate('.icon-heart-active-detail', 'click', function () {
            let id = $(this).data('id');
            let count_vote = parseInt($(this).data('count'));
            count_vote--
            $(this).replaceWith('<div style="cursor: pointer" class="icon-heart-not-active-detail" data-id="' + id + '" data-count="'+ count_vote +'">' +
                '<img src="/images/v2/nha-thau/heart-icon-xam.png" class="icon-heart">' +
                '<span class="text-center" style="color: #6A6A6A; font-size: 15px; margin-left: 5px">'+ count_vote +'</span>' +
                '</div>')
            $.ajax({
                url: '/remove-vote-portfolio',
                method: "delete",
                data: {id: id},
                dataType: 'json',
                beforeSend: function () {
                    $('.overlay').fadeIn();
                },
                success: function (data) {
                    console.log(data)
                    $('.overlay').fadeOut();
                }
            })
        })
    });

    $('.book-load-more').click(function () {
        $('.contractor-portfolio-booking-info__location').toggle();
    })

    $('.book-load-more').mouseover(function (){
        $('.contractor-portfolio-booking-info__location').show();
    })

    $('.book-load-more').mouseout(function (){
        $('.contractor-portfolio-booking-info__location').hide();
    })

    let scrollOverIframe = false;

    function fixedScroll() {
        var top = $('.contractor-portfolio-booking').offset().top - parseFloat($('.contractor-portfolio-booking').css('marginTop').replace(/auto/, 0));
        var footTop = $('#footer').offset().top - parseFloat($('#footer').css('marginTop').replace(/auto/, 0));

        var maxY = footTop - $('.contractor-portfolio-booking').outerHeight();

        $(window).scroll(function() {
            if ($( window ).width() >= 1900) {
                var y = $(this).scrollTop() + 20;
                if (y > top) {
                    scrollOverIframe = true;
                    if (y < maxY) {
                        $('.contractor-portfolio-booking').addClass('fixed').removeAttr('style');
                    } else {
                        $('.contractor-portfolio-booking').removeClass('fixed').css({
                            position: 'absolute',
                            top: (maxY - top) + 'px'
                        });
                    }
                } else {
                    $('.contractor-portfolio-booking').removeClass('fixed');
                    scrollOverIframe = false;
                }
            }
        });
    }

    fixedScroll();

    $(".iframe-3d-viewer").mouseover(function () {
        disableScroll();
    })

    $(".iframe-3d-viewer").mouseleave(function () {
        enableScroll();
    })

    const { body, documentElement } = document;
    let { scrollTop } = document.documentElement;

    function disableScroll() {
        scrollTop = documentElement.scrollTop;
        body.style.top = `-${scrollTop}px`;
        body.classList.add("scroll-disabled");

        if (scrollOverIframe) {
            $('.contractor-portfolio-booking').addClass('sidebar-fixed').css('top', '20px');
        }
    }

    function enableScroll() {
        body.classList.remove("scroll-disabled");
        documentElement.style.scrollBehavior = "auto";
        documentElement.scrollTop = scrollTop;
        documentElement.style.removeProperty("scroll-behavior");
        body.style.removeProperty("top");
        $('.contractor-portfolio-booking').removeClass('sidebar-fixed');
    }
});


